import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { OfflineDialogComponent } from '../components/dialogs/offline-dialog/offline-dialog.component';
import { environment } from '../../environments/environment';
import { DesktopService } from './desktop.service';
import { Router } from '@angular/router';
import { BusinessStatus } from '../store/entities';

@Injectable({
  providedIn: 'root'
})
export class OfflineService {
  dialogRef: MatDialogRef<OfflineDialogComponent> = undefined;

  constructor(public dialog: MatDialog,
              private translate: TranslateService,
              private desktopService: DesktopService,
              private router: Router) { }

  handleOffline(dialog: MatDialog) {
    if (!this.dialogRef) {
      dialog.closeAll();
    } else {
      this.desktopService.getTechnicalInfo().subscribe({
        next: (data) => {
          const status: BusinessStatus = data.datas;
          if (status.bidStatus.type !== 'OK'
          || status.syncStatus.type !== 'FINISHED'
          || status.downloadStatus.type !== 'FINISHED') {
            window.location.reload();
          }
        }
      });
      return;
    }


    this.dialogRef = this.dialog.open(OfflineDialogComponent, {
      disableClose: true,
      data: {
        title: this.translate.get('dialog.user-offline'),
        spinner: true
      }
    });
    this.dialogRef.afterClosed().subscribe(() => {
      window.location.reload();
      this.dialogRef = undefined;
    });
  }

  addEvents() {
    if (this.dialog && !environment.enableDesktopMode) {
      window.addEventListener('offline', () => {
        this.handleOffline(this.dialog);
      });
      window.addEventListener('online', () => {
        this.dialogRef?.close();
      });
    }
  }
}
